namespace Portico.Models.Enterprise {
    import psgm = apigateway.models;

    export interface IAccount extends IBaseAccount {
        patient: Patient;

        addPatient(): Patient;
        mapToEnterpriseCoordinatorAccountUpsearchRequestModel(
            canInsertAccount: boolean,
            canUpdateAccount: boolean,
            skipAccountSearch: boolean,
            canInsertParty: boolean,
            canUpdateParty: boolean,
            skipPartySearch: boolean,
            sourceId?: number
        );
    }

    export class Account extends BaseAccount implements IAccount {
        patient: Patient;

        constructor(obj?: IAccount | any) {
            super(obj);

            this.patient = new Patient();

            if (obj) {
                if (obj.patient) {
                    this.patient = new Patient(obj.patient);
                }
            }
        }

        addPatient(): Patient {
            if (!this.patient) {
                this.patient = new Patient();
            }

            return this.patient;
        }

        mapToEnterpriseCoordinatorAccountUpsearchRequestModel(
            canInsertAccount: boolean,
            canUpdateAccount: boolean,
            skipAccountSearch: boolean,
            canInsertParty: boolean,
            canUpdateParty: boolean,
            skipPartySearch: boolean,
            sourceId: number
        ) {
            const accountDiagnosisSession = this.getDiagnosisSession(false);

            const accountUpsearchModel: psgm.EnterpriseCoordinatorAccountUpsearchRequestModel = {
                accountData: this.mapToEnterpriseCoordinatorAccountUpsearchModelWithFlags(
                    canInsertAccount,
                    canUpdateAccount,
                    skipAccountSearch
                ),
                diagnosisSessionData: accountDiagnosisSession
                    ? accountDiagnosisSession.mapToEnterpriseCoordinatorDiagnosisSessionModel()
                    : null,
                hierarchyExternalIdTypes: [],
                patientData: this.patient
                    ? this.patient.mapToEnterpriseCoordinatorPatientUpsearchModelWithFlags(
                          canInsertParty,
                          canUpdateParty,
                          skipPartySearch
                      )
                    : null,
                payorData: this.payorRelationships
                    ? _.map(this.payorRelationships, (pr) => {
                          return pr.mapToEnterpriseCoordinatorPayorUpsearchModelWithFlags(
                              canInsertParty,
                              canUpdateParty,
                              skipPartySearch
                          );
                      })
                    : [],
                pharmacyData: this.pharmacyRelationships
                    ? _.map(this.pharmacyRelationships, (pr) => {
                          return pr.mapToEnterpriseCoordinatorPharmacyUpsearchModelWithFlags(
                              canInsertParty,
                              canUpdateParty,
                              skipPartySearch
                          );
                      })
                    : [],
                prescriberData: this.prescriberRelationships
                    ? _.map(this.prescriberRelationships, (pr) => {
                          return pr.mapToEnterpriseCoordinatorPrescriberUpsearchModelWithFlags(
                              canInsertParty,
                              canUpdateParty,
                              skipPartySearch
                          );
                      })
                    : [],
                prescriptionData: this.prescriptions
                    ? _.map(this.prescriptions, (p) => {
                          return p.mapToEnterpriseCoordinatorPrescriptionUpsearchModel();
                      })
                    : [],
                siteData: this.siteRelationships
                    ? _.map(this.siteRelationships, (sr) => {
                          return sr.mapToEnterpriseCoordinatorSiteUpsearchModelWithFlags(
                              canInsertParty,
                              canUpdateParty,
                              skipPartySearch
                          );
                      })
                    : [],
                sourceId: sourceId,
                surveySessionData: this.getSurveySessionIds(),
            };
            return accountUpsearchModel;
        }
    }
}
